exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-properties-modal .loading-container {\n  padding: 20%; }\n\n.import-properties-modal .help-text {\n  border-bottom: 1px solid #adb5bd; }\n", ""]);

// exports
